/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigator APP
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 1.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BooleanResponse } from '../models';
import { FileSyncStatusRequest } from '../models';
import { FileSyncStatusViewIEnumerableResponse } from '../models';
import { InvestigationSyncStatusRequest } from '../models';
import { InvestigationSyncStatusViewIEnumerableResponse } from '../models';
import { OtherDataSyncStatusViewIEnumerableResponse } from '../models';
import { StringResponse } from '../models';
import { SyncConflictViewIEnumerableResponse } from '../models';
import { SyncHistoryViewIEnumerableResponse } from '../models';
import { SyncHistoryViewResponse } from '../models';
import { SyncModuleRequest } from '../models';
import { SyncNotificationView } from '../models';
import { TimesheetSyncStatusRequest } from '../models';
import { TimesheetSyncStatusViewIEnumerableResponse } from '../models';
/**
 * SyncHistoryApi - axios parameter creator
 * @export
 */
export const SyncHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {FileSyncStatusRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryGetFileSyncStatusPost: async (body?: FileSyncStatusRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SyncHistory/GetFileSyncStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InvestigationSyncStatusRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryGetInvestigationSyncStatusPost: async (body?: InvestigationSyncStatusRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SyncHistory/GetInvestigationSyncStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryGetLatestSyncJobStatusGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SyncHistory/GetLatestSyncJobStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryGetOtherDataSyncStatusGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SyncHistory/GetOtherDataSyncStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} syncHistoryId 
         * @param {boolean} isResolvedOnly 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryGetSyncConflictsSyncHistoryIdIsResolvedOnlyGet: async (syncHistoryId: number, isResolvedOnly: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'syncHistoryId' is not null or undefined
            if (syncHistoryId === null || syncHistoryId === undefined) {
                throw new RequiredError('syncHistoryId','Required parameter syncHistoryId was null or undefined when calling apiV1SyncHistoryGetSyncConflictsSyncHistoryIdIsResolvedOnlyGet.');
            }
            // verify required parameter 'isResolvedOnly' is not null or undefined
            if (isResolvedOnly === null || isResolvedOnly === undefined) {
                throw new RequiredError('isResolvedOnly','Required parameter isResolvedOnly was null or undefined when calling apiV1SyncHistoryGetSyncConflictsSyncHistoryIdIsResolvedOnlyGet.');
            }
            const localVarPath = `/api/v1/SyncHistory/GetSyncConflicts/{syncHistoryId}/{isResolvedOnly}`
                .replace(`{${"syncHistoryId"}}`, encodeURIComponent(String(syncHistoryId)))
                .replace(`{${"isResolvedOnly"}}`, encodeURIComponent(String(isResolvedOnly)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} isConflictsOnly 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryGetSyncHistoriesIsConflictsOnlyGet: async (isConflictsOnly: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'isConflictsOnly' is not null or undefined
            if (isConflictsOnly === null || isConflictsOnly === undefined) {
                throw new RequiredError('isConflictsOnly','Required parameter isConflictsOnly was null or undefined when calling apiV1SyncHistoryGetSyncHistoriesIsConflictsOnlyGet.');
            }
            const localVarPath = `/api/v1/SyncHistory/GetSyncHistories/{isConflictsOnly}`
                .replace(`{${"isConflictsOnly"}}`, encodeURIComponent(String(isConflictsOnly)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryGetSyncNotificationGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SyncHistory/GetSyncNotification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tableName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryGetSyncStatusTableNameGet: async (tableName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tableName' is not null or undefined
            if (tableName === null || tableName === undefined) {
                throw new RequiredError('tableName','Required parameter tableName was null or undefined when calling apiV1SyncHistoryGetSyncStatusTableNameGet.');
            }
            const localVarPath = `/api/v1/SyncHistory/GetSyncStatus/{tableName}`
                .replace(`{${"tableName"}}`, encodeURIComponent(String(tableName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryGetTableNamesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SyncHistory/GetTableNames`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TimesheetSyncStatusRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryGetTimesheetSyncStatusPost: async (body?: TimesheetSyncStatusRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SyncHistory/GetTimesheetSyncStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistorySyncAllGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SyncHistory/SyncAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SyncModuleRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryUpdateInvestigationByActionPost: async (body?: SyncModuleRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SyncHistory/UpdateInvestigationByAction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SyncModuleRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryUpdateOtherDataByActionPost: async (body?: SyncModuleRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SyncHistory/UpdateOtherDataByAction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SyncModuleRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryUpdateTimesheetByActionPost: async (body?: SyncModuleRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SyncHistory/UpdateTimesheetByAction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SyncHistoryApi - functional programming interface
 * @export
 */
export const SyncHistoryApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {FileSyncStatusRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SyncHistoryGetFileSyncStatusPost(body?: FileSyncStatusRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileSyncStatusViewIEnumerableResponse>> {
            const localVarAxiosArgs = await SyncHistoryApiAxiosParamCreator(configuration).apiV1SyncHistoryGetFileSyncStatusPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {InvestigationSyncStatusRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SyncHistoryGetInvestigationSyncStatusPost(body?: InvestigationSyncStatusRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationSyncStatusViewIEnumerableResponse>> {
            const localVarAxiosArgs = await SyncHistoryApiAxiosParamCreator(configuration).apiV1SyncHistoryGetInvestigationSyncStatusPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SyncHistoryGetLatestSyncJobStatusGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await SyncHistoryApiAxiosParamCreator(configuration).apiV1SyncHistoryGetLatestSyncJobStatusGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SyncHistoryGetOtherDataSyncStatusGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OtherDataSyncStatusViewIEnumerableResponse>> {
            const localVarAxiosArgs = await SyncHistoryApiAxiosParamCreator(configuration).apiV1SyncHistoryGetOtherDataSyncStatusGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} syncHistoryId 
         * @param {boolean} isResolvedOnly 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SyncHistoryGetSyncConflictsSyncHistoryIdIsResolvedOnlyGet(syncHistoryId: number, isResolvedOnly: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncConflictViewIEnumerableResponse>> {
            const localVarAxiosArgs = await SyncHistoryApiAxiosParamCreator(configuration).apiV1SyncHistoryGetSyncConflictsSyncHistoryIdIsResolvedOnlyGet(syncHistoryId, isResolvedOnly, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {boolean} isConflictsOnly 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SyncHistoryGetSyncHistoriesIsConflictsOnlyGet(isConflictsOnly: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncHistoryViewIEnumerableResponse>> {
            const localVarAxiosArgs = await SyncHistoryApiAxiosParamCreator(configuration).apiV1SyncHistoryGetSyncHistoriesIsConflictsOnlyGet(isConflictsOnly, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SyncHistoryGetSyncNotificationGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncNotificationView>> {
            const localVarAxiosArgs = await SyncHistoryApiAxiosParamCreator(configuration).apiV1SyncHistoryGetSyncNotificationGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} tableName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SyncHistoryGetSyncStatusTableNameGet(tableName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncHistoryViewResponse>> {
            const localVarAxiosArgs = await SyncHistoryApiAxiosParamCreator(configuration).apiV1SyncHistoryGetSyncStatusTableNameGet(tableName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SyncHistoryGetTableNamesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponse>> {
            const localVarAxiosArgs = await SyncHistoryApiAxiosParamCreator(configuration).apiV1SyncHistoryGetTableNamesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {TimesheetSyncStatusRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SyncHistoryGetTimesheetSyncStatusPost(body?: TimesheetSyncStatusRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimesheetSyncStatusViewIEnumerableResponse>> {
            const localVarAxiosArgs = await SyncHistoryApiAxiosParamCreator(configuration).apiV1SyncHistoryGetTimesheetSyncStatusPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SyncHistorySyncAllGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await SyncHistoryApiAxiosParamCreator(configuration).apiV1SyncHistorySyncAllGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {SyncModuleRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SyncHistoryUpdateInvestigationByActionPost(body?: SyncModuleRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await SyncHistoryApiAxiosParamCreator(configuration).apiV1SyncHistoryUpdateInvestigationByActionPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {SyncModuleRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SyncHistoryUpdateOtherDataByActionPost(body?: SyncModuleRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await SyncHistoryApiAxiosParamCreator(configuration).apiV1SyncHistoryUpdateOtherDataByActionPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {SyncModuleRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SyncHistoryUpdateTimesheetByActionPost(body?: SyncModuleRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await SyncHistoryApiAxiosParamCreator(configuration).apiV1SyncHistoryUpdateTimesheetByActionPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SyncHistoryApi - factory interface
 * @export
 */
export const SyncHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {FileSyncStatusRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryGetFileSyncStatusPost(body?: FileSyncStatusRequest, options?: any): AxiosPromise<FileSyncStatusViewIEnumerableResponse> {
            return SyncHistoryApiFp(configuration).apiV1SyncHistoryGetFileSyncStatusPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvestigationSyncStatusRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryGetInvestigationSyncStatusPost(body?: InvestigationSyncStatusRequest, options?: any): AxiosPromise<InvestigationSyncStatusViewIEnumerableResponse> {
            return SyncHistoryApiFp(configuration).apiV1SyncHistoryGetInvestigationSyncStatusPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryGetLatestSyncJobStatusGet(options?: any): AxiosPromise<BooleanResponse> {
            return SyncHistoryApiFp(configuration).apiV1SyncHistoryGetLatestSyncJobStatusGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryGetOtherDataSyncStatusGet(options?: any): AxiosPromise<OtherDataSyncStatusViewIEnumerableResponse> {
            return SyncHistoryApiFp(configuration).apiV1SyncHistoryGetOtherDataSyncStatusGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} syncHistoryId 
         * @param {boolean} isResolvedOnly 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryGetSyncConflictsSyncHistoryIdIsResolvedOnlyGet(syncHistoryId: number, isResolvedOnly: boolean, options?: any): AxiosPromise<SyncConflictViewIEnumerableResponse> {
            return SyncHistoryApiFp(configuration).apiV1SyncHistoryGetSyncConflictsSyncHistoryIdIsResolvedOnlyGet(syncHistoryId, isResolvedOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} isConflictsOnly 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryGetSyncHistoriesIsConflictsOnlyGet(isConflictsOnly: boolean, options?: any): AxiosPromise<SyncHistoryViewIEnumerableResponse> {
            return SyncHistoryApiFp(configuration).apiV1SyncHistoryGetSyncHistoriesIsConflictsOnlyGet(isConflictsOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryGetSyncNotificationGet(options?: any): AxiosPromise<SyncNotificationView> {
            return SyncHistoryApiFp(configuration).apiV1SyncHistoryGetSyncNotificationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tableName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryGetSyncStatusTableNameGet(tableName: string, options?: any): AxiosPromise<SyncHistoryViewResponse> {
            return SyncHistoryApiFp(configuration).apiV1SyncHistoryGetSyncStatusTableNameGet(tableName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryGetTableNamesGet(options?: any): AxiosPromise<StringResponse> {
            return SyncHistoryApiFp(configuration).apiV1SyncHistoryGetTableNamesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TimesheetSyncStatusRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryGetTimesheetSyncStatusPost(body?: TimesheetSyncStatusRequest, options?: any): AxiosPromise<TimesheetSyncStatusViewIEnumerableResponse> {
            return SyncHistoryApiFp(configuration).apiV1SyncHistoryGetTimesheetSyncStatusPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistorySyncAllGet(options?: any): AxiosPromise<BooleanResponse> {
            return SyncHistoryApiFp(configuration).apiV1SyncHistorySyncAllGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SyncModuleRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryUpdateInvestigationByActionPost(body?: SyncModuleRequest, options?: any): AxiosPromise<BooleanResponse> {
            return SyncHistoryApiFp(configuration).apiV1SyncHistoryUpdateInvestigationByActionPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SyncModuleRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryUpdateOtherDataByActionPost(body?: SyncModuleRequest, options?: any): AxiosPromise<BooleanResponse> {
            return SyncHistoryApiFp(configuration).apiV1SyncHistoryUpdateOtherDataByActionPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SyncModuleRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SyncHistoryUpdateTimesheetByActionPost(body?: SyncModuleRequest, options?: any): AxiosPromise<BooleanResponse> {
            return SyncHistoryApiFp(configuration).apiV1SyncHistoryUpdateTimesheetByActionPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SyncHistoryApi - object-oriented interface
 * @export
 * @class SyncHistoryApi
 * @extends {BaseAPI}
 */
export class SyncHistoryApi extends BaseAPI {
    /**
     * 
     * @param {FileSyncStatusRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncHistoryApi
     */
    public apiV1SyncHistoryGetFileSyncStatusPost(body?: FileSyncStatusRequest, options?: any) {
        return SyncHistoryApiFp(this.configuration).apiV1SyncHistoryGetFileSyncStatusPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {InvestigationSyncStatusRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncHistoryApi
     */
    public apiV1SyncHistoryGetInvestigationSyncStatusPost(body?: InvestigationSyncStatusRequest, options?: any) {
        return SyncHistoryApiFp(this.configuration).apiV1SyncHistoryGetInvestigationSyncStatusPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncHistoryApi
     */
    public apiV1SyncHistoryGetLatestSyncJobStatusGet(options?: any) {
        return SyncHistoryApiFp(this.configuration).apiV1SyncHistoryGetLatestSyncJobStatusGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncHistoryApi
     */
    public apiV1SyncHistoryGetOtherDataSyncStatusGet(options?: any) {
        return SyncHistoryApiFp(this.configuration).apiV1SyncHistoryGetOtherDataSyncStatusGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} syncHistoryId 
     * @param {boolean} isResolvedOnly 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncHistoryApi
     */
    public apiV1SyncHistoryGetSyncConflictsSyncHistoryIdIsResolvedOnlyGet(syncHistoryId: number, isResolvedOnly: boolean, options?: any) {
        return SyncHistoryApiFp(this.configuration).apiV1SyncHistoryGetSyncConflictsSyncHistoryIdIsResolvedOnlyGet(syncHistoryId, isResolvedOnly, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {boolean} isConflictsOnly 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncHistoryApi
     */
    public apiV1SyncHistoryGetSyncHistoriesIsConflictsOnlyGet(isConflictsOnly: boolean, options?: any) {
        return SyncHistoryApiFp(this.configuration).apiV1SyncHistoryGetSyncHistoriesIsConflictsOnlyGet(isConflictsOnly, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncHistoryApi
     */
    public apiV1SyncHistoryGetSyncNotificationGet(options?: any) {
        return SyncHistoryApiFp(this.configuration).apiV1SyncHistoryGetSyncNotificationGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} tableName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncHistoryApi
     */
    public apiV1SyncHistoryGetSyncStatusTableNameGet(tableName: string, options?: any) {
        return SyncHistoryApiFp(this.configuration).apiV1SyncHistoryGetSyncStatusTableNameGet(tableName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncHistoryApi
     */
    public apiV1SyncHistoryGetTableNamesGet(options?: any) {
        return SyncHistoryApiFp(this.configuration).apiV1SyncHistoryGetTableNamesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {TimesheetSyncStatusRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncHistoryApi
     */
    public apiV1SyncHistoryGetTimesheetSyncStatusPost(body?: TimesheetSyncStatusRequest, options?: any) {
        return SyncHistoryApiFp(this.configuration).apiV1SyncHistoryGetTimesheetSyncStatusPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncHistoryApi
     */
    public apiV1SyncHistorySyncAllGet(options?: any) {
        return SyncHistoryApiFp(this.configuration).apiV1SyncHistorySyncAllGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {SyncModuleRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncHistoryApi
     */
    public apiV1SyncHistoryUpdateInvestigationByActionPost(body?: SyncModuleRequest, options?: any) {
        return SyncHistoryApiFp(this.configuration).apiV1SyncHistoryUpdateInvestigationByActionPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {SyncModuleRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncHistoryApi
     */
    public apiV1SyncHistoryUpdateOtherDataByActionPost(body?: SyncModuleRequest, options?: any) {
        return SyncHistoryApiFp(this.configuration).apiV1SyncHistoryUpdateOtherDataByActionPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {SyncModuleRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncHistoryApi
     */
    public apiV1SyncHistoryUpdateTimesheetByActionPost(body?: SyncModuleRequest, options?: any) {
        return SyncHistoryApiFp(this.configuration).apiV1SyncHistoryUpdateTimesheetByActionPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
